/**
 * @description TOPIC配置 topicConfig
 * @author 系统生成
 * @date 2018/9/20
 */

import Logic from '../logic-base'

const topicConfigBiz = new Logic()

topicConfigBiz.addTopic = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.topicConfig.addTopic,
    data: data
  })
}

topicConfigBiz.deleteTopic = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.topicConfig.deleteTopic,
    data: data
  })
}

topicConfigBiz.getTopic = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.topicConfig.getTopic,
    data: data
  })
}

topicConfigBiz.updateTopic = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.topicConfig.updateTopic,
    data: data
  })
}

export default topicConfigBiz
